import type { TipoArredondamento, TipoFinais } from '../@types/IPA/PrecoPsicologico';

const DIVISOR_POR_TIPO: Record<TipoFinais, number> = {
  1: 0.10,
  2: 1.00,
  3: 10.00,
  4: 100.00,
  5: 1000.00,
};

interface ContextoEscolha {
  candidato: number;
  preco: number;
  distancia: number;
  melhorDistancia: number;
  melhorCandidato: number | null;
}

const DEVE_ESCOLHER: Record<TipoArredondamento, (ctx: ContextoEscolha) => boolean> = {
  MAIS_PROXIMO: ({ candidato, distancia, melhorDistancia, melhorCandidato }) =>
    distancia < melhorDistancia ||
    (distancia === melhorDistancia && melhorCandidato !== null && candidato > melhorCandidato),
  SEMPRE_PARA_CIMA: ({ candidato, preco, distancia, melhorDistancia }) =>
    candidato >= preco && distancia < melhorDistancia,
  SEMPRE_PARA_BAIXO: ({ candidato, preco, distancia, melhorDistancia }) =>
    candidato <= preco && distancia < melhorDistancia,
};

export function simularPrecoLocal(
  preco: number,
  finais: string[],
  tipo: TipoFinais,
  opcao: TipoArredondamento,
): { precoSimulado: number; finalAplicado: string } | null {
  if (finais.length === 0 || preco <= 0) return null;

  const divisor = DIVISOR_POR_TIPO[tipo];
  const deveEscolher = DEVE_ESCOLHER[opcao];
  let melhorCandidato: number | null = null;
  let melhorDistancia = Infinity;
  let melhorFinal = '';

  for (const final of finais) {
    const valorFinal = parseFinal(final, tipo);
    const candidatos = gerarCandidatos(preco, valorFinal, divisor);

    for (const candidato of candidatos) {
      if (candidato <= 0) continue;

      const distancia = Math.abs(candidato - preco);
      const escolher = deveEscolher({ candidato, preco, distancia, melhorDistancia, melhorCandidato });

      if (escolher) {
        melhorCandidato = candidato;
        melhorDistancia = distancia;
        melhorFinal = final;
      }
    }
  }

  if (melhorCandidato === null) return null;

  return {
    precoSimulado: Math.round(melhorCandidato * 100) / 100,
    finalAplicado: melhorFinal,
  };
}

function parseFinal(final: string, tipo: TipoFinais): number {
  if (tipo <= 2) return parseInt(final, 10) / 100;
  return parseFloat(final.replace(',', '.'));
}

function gerarCandidatos(preco: number, valorFinal: number, divisor: number): number[] {
  const base = Math.floor(preco / divisor) * divisor;
  return [base + valorFinal - divisor, base + valorFinal, base + valorFinal + divisor];
}
